import { ColumnDef } from '@tanstack/react-table';
import { format } from 'date-fns';
import { formatISODate } from '@/utils/date';
import {
  SortableHeader,
  TruncatedCell,
  DownloadedCheckmark,
} from '@/components';
import { PathologyResultRecord } from '../types';
import { PatientDocumentViewButton } from '../../components';
import { DocumentSource, DocumentType } from '../../viewer';

export const createPathologyResultsColumns =
  (): ColumnDef<PathologyResultRecord>[] => [
    {
      accessorKey: 'name',
      header: 'Name',
      cell: ({ row }) =>
        row.original.name ? (
          <TruncatedCell text={row.original.name} />
        ) : (
          'No data available'
        ),
    },
    {
      id: 'dateOfStudy',
      accessorKey: 'dateOfStudy',
      enableSorting: true,
      header: ({ column }) => (
        <SortableHeader column={column}>Date of Study</SortableHeader>
      ),
      cell: ({ row }) => formatISODate(row.original.dateOfStudy),
    },
    {
      accessorKey: 'specimenSource',
      header: 'Specimen Source',
      cell: ({ row }) => row.original.specimenSource || 'No data available',
    },
    {
      accessorKey: 'diagnosis',
      header: 'Diagnosis',
      cell: ({ row }) => row.original.diagnosis || 'No data available',
    },
    {
      id: 'dateUploaded',
      accessorFn: (row) => row.createdAt,
      enableSorting: true,
      header: ({ column }) => (
        <SortableHeader column={column}>Date Uploaded</SortableHeader>
      ),
      cell: ({ row }) =>
        row.original.createdAt
          ? format(new Date(row.original.createdAt), 'MM/dd/yyyy')
          : 'No data available',
    },
    {
      accessorKey: 'sourceType',
      enableSorting: true,
      header: ({ column }) => (
        <SortableHeader column={column}>Source Type</SortableHeader>
      ),
      cell: ({ row }) => row.original.sourceType || 'No data available',
    },
    {
      id: 'markedDownloaded',
      enableSorting: false,
      header: '',
      cell: ({ row }) =>
        row.original.markedDownloaded ? <DownloadedCheckmark /> : null,
    },
    {
      id: 'actions',
      enableSorting: false,
      header: '',
      cell: ({ row }) => (
        <div className="flex items-center justify-end gap-1">
          <PatientDocumentViewButton
            disabled={!row.original.sourceType}
            documentKey={{
              source: DocumentSource.MEDICAL_RECORDS,
              type: DocumentType.PATHOLOGY_RESULTS,
              pathologyId: row.original.id,
              sourceType: row.original.sourceType,
              name: row.original.name,
            }}
          />
        </div>
      ),
    },
  ];
